module.exports = __webpack_public_path__ + "resources/img/img_nginx2_en.f679ed3c4eef6aac3774639b988a9cee.png";